class ModalSpeakers {
    constructor() {
        this.initModal();
        this.initSpeakers();
    }

    initModal() {
        this.el = document.querySelector('#speakers-modal');

        this.closeButton = this.el.querySelector('.close');
        this.modalInner = this.el.querySelector('.modal-inner');
        this.modalBox = this.el.querySelector('.portfolio-modal-box');
        this.nameEl = this.el.querySelector('.name');
        this.titleEl = this.el.querySelector('.designation');
        this.bioEl = this.el.querySelector('.speaker-desc div');
        this.imageEl = this.el.querySelector('.img img');
        this.headerBgWrappers = this.el.querySelectorAll('.speaker-info .bg');
        this.userNetwork = this.el.querySelector('.user-network');

        if (this.closeButton) {
            this.closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        }

        if (this.modalInner) {
            this.modalInner.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        }

        if (this.modalBox) {
            this.modalBox.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
    }

    initSpeakers() {
        const speakers = [...document.querySelectorAll('[data-speaker]')];
        speakers.forEach((speaker) => {
            speaker.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.el.classList.contains('disable-modal')) return;
                this.open(speaker);
            });
        });
    }

    open(speakerEl) {
        this.el.classList.add('show');

        const name = speakerEl.dataset.speakerName;
        const title = speakerEl.dataset.speakerCompany;
        const bio = speakerEl.dataset.speakerBio;
        const image = speakerEl.dataset.speakerPhoto;
        const headerBgImage = speakerEl.dataset.speakerHeaderBg;

        this.nameEl.innerHTML = name;
        this.titleEl.innerHTML = title;
        this.bioEl.innerHTML = bio;
        this.imageEl.src = image;

        this.headerBgWrappers.forEach(function (bgWrapper) {
            bgWrapper.innerHTML = '';

            if(headerBgImage) {
                const img = document.createElement('img');
                img.src = headerBgImage;
                img.alt = '';
                bgWrapper.appendChild(img);
            }
        });

        this.userNetwork.innerHTML = '';

        const socials = JSON.parse(speakerEl.dataset.socials);

        if (socials && socials.length > 0) {
            for (const social of socials) {
                const li = document.createElement('li');
                const a = document.createElement('a');
                a.href = social.url;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                const i = document.createElement('i');
                i.className = social['constants.select.social_icons'];
                a.appendChild(i);
                li.appendChild(a);
                this.userNetwork.appendChild(li);
            }
        }
    }

    close() {
        this.el.classList.remove('show');
    }
}

export default ModalSpeakers;
